"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Task = function Task(props) {
  return _react.default.createElement("svg", {
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, _react.default.createElement("title", null, props.altText), _react.default.createElement("rect", {
    width: "24",
    height: "24",
    fill: props.backgroundColor
  }), _react.default.createElement("g", {
    opacity: "0.5"
  }, _react.default.createElement("path", {
    opacity: "0.5",
    d: "M8 14V18H12H16V6H12H8V14Z",
    fill: props.foregroundColor
  }), _react.default.createElement("path", {
    opacity: "0.5",
    d: "M16 18.5H8C7.86739 18.5 7.74021 18.4473 7.64645 18.3536C7.55268 18.2598 7.5 18.1326 7.5 18V6C7.5 5.86739 7.55268 5.74021 7.64645 5.64645C7.74021 5.55268 7.86739 5.5 8 5.5H16C16.1326 5.5 16.2598 5.55268 16.3536 5.64645C16.4473 5.74021 16.5 5.86739 16.5 6V18C16.5 18.1326 16.4473 18.2598 16.3536 18.3536C16.2598 18.4473 16.1326 18.5 16 18.5ZM8.5 17.5H15.5V6.5H8.5V17.5Z",
    fill: props.foregroundColor
  })), _react.default.createElement("path", {
    d: "M15 10.5H9C8.86739 10.5 8.74021 10.4473 8.64645 10.3536C8.55268 10.2598 8.5 10.1326 8.5 10C8.5 9.86739 8.55268 9.74021 8.64645 9.64645C8.74021 9.55268 8.86739 9.5 9 9.5H15C15.1326 9.5 15.2598 9.55268 15.3536 9.64645C15.4473 9.74021 15.5 9.86739 15.5 10C15.5 10.1326 15.4473 10.2598 15.3536 10.3536C15.2598 10.4473 15.1326 10.5 15 10.5Z",
    fill: props.foregroundColor
  }), _react.default.createElement("path", {
    d: "M15 14.5H9C8.86739 14.5 8.74021 14.4473 8.64645 14.3536C8.55268 14.2598 8.5 14.1326 8.5 14C8.5 13.8674 8.55268 13.7402 8.64645 13.6464C8.74021 13.5527 8.86739 13.5 9 13.5H15C15.1326 13.5 15.2598 13.5527 15.3536 13.6464C15.4473 13.7402 15.5 13.8674 15.5 14C15.5 14.1326 15.4473 14.2598 15.3536 14.3536C15.2598 14.4473 15.1326 14.5 15 14.5Z",
    fill: props.foregroundColor
  }), _react.default.createElement("path", {
    d: "M15 16.5H9C8.86739 16.5 8.74021 16.4473 8.64645 16.3536C8.55268 16.2598 8.5 16.1326 8.5 16C8.5 15.8674 8.55268 15.7402 8.64645 15.6464C8.74021 15.5527 8.86739 15.5 9 15.5H15C15.1326 15.5 15.2598 15.5527 15.3536 15.6464C15.4473 15.7402 15.5 15.8674 15.5 16C15.5 16.1326 15.4473 16.2598 15.3536 16.3536C15.2598 16.4473 15.1326 16.5 15 16.5Z",
    fill: props.foregroundColor
  }), _react.default.createElement("path", {
    d: "M15 12.5H9C8.86739 12.5 8.74021 12.4473 8.64645 12.3536C8.55268 12.2598 8.5 12.1326 8.5 12C8.5 11.8674 8.55268 11.7402 8.64645 11.6464C8.74021 11.5527 8.86739 11.5 9 11.5H15C15.1326 11.5 15.2598 11.5527 15.3536 11.6464C15.4473 11.7402 15.5 11.8674 15.5 12C15.5 12.1326 15.4473 12.2598 15.3536 12.3536C15.2598 12.4473 15.1326 12.5 15 12.5Z",
    fill: props.foregroundColor
  }), _react.default.createElement("path", {
    d: "M14 4.5H10C9.86739 4.5 9.74021 4.55268 9.64645 4.64645C9.55268 4.74021 9.5 4.86739 9.5 5V6.5H14.5V5C14.5 4.86739 14.4473 4.74021 14.3536 4.64645C14.2598 4.55268 14.1326 4.5 14 4.5Z",
    fill: props.foregroundColor
  }));
};

Task.defaultProps = {
  altText: "Task",
  backgroundColor: "#212121",
  foregroundColor: "#FFFFFF"
};
Task.propTypes = {
  altText: _propTypes.default.string,
  backgroundColor: _propTypes.default.string,
  foregroundColor: _propTypes.default.string
};
var _default = Task;
exports.default = _default;